import * as Yup from 'yup';
import useCommanValidationFields from './common';
import useValidationFields from './fields';
import { useOneToOneMeetingFields, useQuickAddEndUserFields } from './oneToOneMeetingFormValidation';
import { useTSIContractorDetailFormFields } from './TSIContractorForm';
import { useTSIQuickEndMeetingFormValidation } from './TSIQuickEndMeetingFormValidation';
import { ISupervisorFields, useSupervisorValidationFields } from '@hooks/validations/supervisorForm';
import { phoneRegExp } from '@config/constant';

// TODO:: Need to implement type of the schemas.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useValidation = () => {
	const { first_name, last_name, middle_name, religion, language, birth_date, email } = useCommanValidationFields();
	const {
		primary_number,
		secondary_number,
		sites_worked,
		sites_competition,
		average_glue,
		calculated_glue,
		permanent_town,
		permanent_address,
		permanent_city,
		permanent_state,
		permanent_street,
		permanent_zipcode,
		local_address,
		local_city,
		local_state,
		local_street,
		local_zipcode,
		work_address,
		work_city,
		work_state,
		work_street,
		work_zipcode,
		club,
		primary_details,
		average_glue_potential,
		no_of_carpenters,
		workshop_address,
		workshop_zipcode,
		workshop_city,
		workshop_street,
		workshop_state,
		competition_details,
		siteName,
		siteLocation,
		gradeUsed,
		contractType,
		competitionReason,
		contractorName,
		contractorNumber,
		title,
		meeting_venue_c,
		startdate,
		enddate,
		end_time_c,
		start_time_c,
		electionNominationEndDate,
		electionNominationEndTime,
		dealerName,
		gluePotentialOfSite,
		architect_details,
		influencer_details,
		owner_details,
		kyc_file_name,
		name,
		contact,
		town,
		meetingVenue,
		meetingTheme,
		meetingType,
		mdi,
		rbdmTown,
		productDiscussed,
		primaryFocusProduct,
		meetFormat,
		productHierarchyCode,
		catagories,
		designation,
		natureOfWork,
		userToBeLinked,
		learningForm,
		obstacleFaced,
		meeting_expenses,
		food,
		venue,
		gifts,
		others,
		exception,
		activityDiscussed,
		productRSI,
		address,
		contractorNumber1,
		contractorNumber2,
		contractorName1,
		contractorName2,
		factory_address,
		factory_city,
		factory_state,
		factory_zipcode,
		veneer,
		isContractorAvailable,
		isWeatherWorkGivenToJoinery,
		joineryName,
		joineryNumber,
		joineryAddress,
		isWorkGivenToFactory,
		siteAddressFactoryName,
		siteAddressFactoryNumber,
		siteAddressFactoryAddress,
		substratesCombinations,
		glueUsedAtSite,
		meetingClub,
		meetingDealer,
		competitionConsumption,
		factoryName,
		factoryLocation,
		brandNoticed,
		brand,
		chargeToVisitContractor,
		brandOthers,
		factory_visit_feedback,
		siteSpecialist,
		superVisorNumber,
		superVisorName,
		superVisorNumberRequired,
		superVisorNameRequired,
		competitionGlueUsedSoFar,
		fvGlueUsedSoFar,
		noOfActiveSites,
		siteType,
		typeOfProperty,
		propertyArea,
		siteStage,
		brandAvailable,
		glueUsedSoFar,
		conversionPotential,
		siteSubStage,
		tentativeNextVisit,
		glueConsumed,
		personAtSite,
		reasonForCompetition,
		personConvince,
		followUpDate,
		productDemo,
		unsuccessfulDemoReason,
		conversionVolume,
		fevicolProduct,
		totalConversionVolume,
		noOfSites,
		contractorPotentialPerMonth,
		assigneCmdi,
		conversionType,
		followUpReason,
		followUpDateForVisit3Plus,
		availableOtherProductsDemoed,
		availableOtherProductsDiscussed,
		feedback,
		productComplaintLast1Month,
		complaintProductsList,
		productComplaintDescription,
		customProductComplaintDescription,
		secondaryCompetitionReason,
		secondaryCompetitionReasonOther,
		meetSubCategory,
		meetingPhotos,
		primaryFocusProductLcdMeets,
		secondary_club,
		brandUsed,
		meetingMdpClub,
		workshop_checkbox,
		factory_checkbox,
		interior_work,
		what_kind_of_jobs_do_you_undertake,
		work_do_you_generally_undertake,
		monthlyaverageconsumptionfhi_c,
		enable_carpenter_option,
		boss_name,
		boss_mobile,
	} = useValidationFields();

	const { endUser, typeOfActivity, otherTypeOfActivity, Product1Demo, meetingTime } = useOneToOneMeetingFields();
	const { firstName, lastName, mobileNumber, endUserCategory, primaryDealer, wssTerritory, zipcode } =
		useQuickAddEndUserFields();
	const TSIContractorFormFields = useTSIContractorDetailFormFields();
	const TSIQuickEndMeetingFormFields = useTSIQuickEndMeetingFormValidation();
	const { largeContractor } = useSupervisorValidationFields();

	const basicDetailsValidationSchema = Yup.object({
		first_name: first_name,
		last_name: last_name,
		middle_name: middle_name,
		religion: religion,
		language: language,
		primary_number: primary_number,
		secondary_number: secondary_number,
		sites_worked: sites_worked,
		sites_competition: sites_competition,
		average_glue: average_glue,
		competitionConsumption: competitionConsumption,
		calculated_glue: calculated_glue,
		permanent_town: permanent_town,
		permanent_address: permanent_address,
		permanent_city: permanent_city,
		permanent_state: permanent_state,
		permanent_street: permanent_street,
		permanent_zipcode: permanent_zipcode,
		local_address: local_address,
		local_city: local_city,
		local_state: local_state,
		local_street: local_street,
		local_zipcode: local_zipcode,
		work_address: work_address,
		work_city: work_city,
		work_state: work_state,
		work_street: work_street,
		work_zipcode: work_zipcode,
		birth_date: birth_date,
		email: email,
		monthlyaverageconsumptionfhi_c: monthlyaverageconsumptionfhi_c,
	});

	const KYCDetailsValidationSchema = Yup.object({
		kyc_file_name: kyc_file_name,
	});
	const MoreDetailsValidationSchema = Yup.object({
		club,
		primary_details: primary_details,
		competition_details: competition_details,
		average_glue_potential: average_glue_potential,
		no_of_carpenters: no_of_carpenters,
		workshop_address: workshop_address,
		workshop_zipcode: workshop_zipcode,
		workshop_city: workshop_city,
		workshop_street: workshop_street,
		workshop_state: workshop_state,
		architect_details: architect_details,
		influencer_details: influencer_details,
		factory_address: factory_address,
		factory_city: factory_city,
		factory_state: factory_state,
		factory_zipcode: factory_zipcode,
		workshop_checkbox: workshop_checkbox,
		factory_checkbox: factory_checkbox,
		interior_work: interior_work,
		what_kind_of_jobs_do_you_undertake: what_kind_of_jobs_do_you_undertake,
		work_do_you_generally_undertake: work_do_you_generally_undertake,
		enable_carpenter_option: enable_carpenter_option,
		boss_name: boss_name,
		boss_mobile: boss_mobile,
	});

	const AddSiteLeadValidationSchema = Yup.object({
		siteName: siteName,
		siteLocation: siteLocation,
		brandUsed: brandUsed,
		gradeUsed: gradeUsed,
		contractType: contractType,
		competitionReason: competitionReason,
		secondaryCompetitionReason: secondaryCompetitionReason,
		secondaryCompetitionReasonOther: secondaryCompetitionReasonOther,
		contractorName: contractorName,
		contractorNumber: contractorNumber,
		substratesCombinations: substratesCombinations,
		glueUsedAtSite: glueUsedAtSite,
		builder_name: Yup.string().nullable(),
		builder_phone_number: Yup.string().nullable(),
		builder_office_address: Yup.string().nullable(),
	});

	const AddKAESSSiteLeadValidationSchema = Yup.object({
		siteName: siteName,
		siteLocation: siteLocation,
		gradeUsed: gradeUsed,
		contractType: contractType,
		competitionReason: competitionReason,
		contractorName: contractorName,
		contractorNumber: contractorNumber,
		substratesCombinations: substratesCombinations,
		glueUsedAtSite: glueUsedAtSite,
		superVisorName: superVisorNameRequired,
		superVisorNumber: superVisorNumberRequired,
		brandUsed: brandUsed,
	});

	const AddMeetingValidationSchema = Yup.object({
		startdate: startdate,
		enddate: enddate,
		start_time_c: start_time_c,
		end_time_c: end_time_c,
		electionNominationEndDate: electionNominationEndDate,
		electionNominationEndTime: electionNominationEndTime,
		name: name,
		contact: contact,
		town: town,
		meetingVenue: meetingVenue,
		meetingType: meetingType,
		mdi: mdi,
		primaryFocusProduct: primaryFocusProduct,
		product1Discussed: productDiscussed,
		product2Discussed: productDiscussed,
		meetFormat: meetFormat,
		club: meetingClub,
		dealer: meetingDealer,
		meetSubCategory: meetSubCategory,
		primaryFocusProductLcdMeets: primaryFocusProductLcdMeets,
	});

	const UpdateMeetingValidationSchema = Yup.object({
		primaryFocusProduct: primaryFocusProduct,
		product1Discussed: productDiscussed,
		product2Discussed: productDiscussed,
	});
	const SiteAddressValidationSchema = Yup.object({
		dealerName: dealerName,
		gluePotentialOfSite: gluePotentialOfSite,
		architect_details: architect_details,
		owner_details: owner_details,
		veneer: veneer,
		isContractorAvailable: isContractorAvailable,
		isWeatherWorkGivenToJoinery: isWeatherWorkGivenToJoinery,
		joineryName: joineryName,
		joineryNumber: joineryNumber,
		joineryAddress: joineryAddress,
		isWorkGivenToFactory: isWorkGivenToFactory,
		factoryName: siteAddressFactoryName,
		factoryNumber: siteAddressFactoryNumber,
		factoryAddress: siteAddressFactoryAddress,
		competitionGlueUsedSoFar: competitionGlueUsedSoFar,
		fvGlueUsedSoFar: fvGlueUsedSoFar,
		noOfActiveSites: noOfActiveSites,
		availableOtherProductsDemoed: availableOtherProductsDemoed,
		availableOtherProductsDiscussed: availableOtherProductsDiscussed,
		productComplaintLast1Month: productComplaintLast1Month,
		complaintProductsList: complaintProductsList,
		productComplaintDescription: productComplaintDescription,
		customProductComplaintDescription: customProductComplaintDescription,
	});
	const SiteProductsValidationSchema = Yup.object({});

	const TaskListValidationSchema = Yup.object({
		productFeedback: Yup.string()
			.required('Product Feedback is required')
			.min(2, 'Product Feedback must be at least 2 characters'),
		anyFeedback: Yup.string().required('Any Feedback is required').min(2, 'Any Feedback must be at least 2 characters'),
		feedback: feedback,
		exception: exception,
	});

	const CalendarSchema = Yup.object({
		title: title,
		meeting_venue_c: meeting_venue_c,
		startdate: startdate,
		enddate: enddate,
		end_time_c: end_time_c,
		start_time_c: start_time_c,
	});

	const AddUserSchema = Yup.object({
		firstName: first_name,
		lastName: last_name,
		primary_number: primary_number,
		secondary_number: secondary_number,
		productHierarchyCode: productHierarchyCode,
		...TSIQuickEndMeetingFormFields,
	});

	const NonEndUserSchema = Yup.object({
		catagories: catagories,
		designation: designation,
		natureOfWork: natureOfWork,
		userToBeLinked: userToBeLinked,
		firstName: first_name,
		lastName: last_name,
		primary_number: primary_number,
		secondary_number: secondary_number,
		productHierarchyCode: productHierarchyCode,
	});

	const FeedbackValidationSchema = Yup.object({
		obstacleFaced: obstacleFaced,
		learningForm: learningForm,
		meetingPhotos: meetingPhotos,
	});

	const ExpenseValidationSchema = Yup.object({
		meetingExpense: meeting_expenses,
		foodCost: food,
		venueCost: venue,
		giftCost: gifts,
		otherCost: others,
	});

	const DealerVisitValidationSchema = Yup.object({
		dealerName: dealerName,
		siteLocation: siteLocation,
		activityDiscussed: activityDiscussed,
		productRSI: productRSI,
		address: address,
		contractorNumber1: contractorNumber1,
		contractorNumber2: contractorNumber2,
		contractorName1: contractorName1,
		contractorName2: contractorName2,
	});

	const OneToOneMeetingValidationSchema = Yup.object({
		endUser: endUser,
		typeOfActivity: typeOfActivity,
		otherTypeOfActivity: otherTypeOfActivity,
		Product1Demo: Product1Demo,
		meetingTime: meetingTime,
	});

	const supervisorValidation: Yup.ObjectSchema<ISupervisorFields> = Yup.object({
		firstname: first_name,
		middlename: middle_name,
		lastname: last_name,
		phone: primary_number,
		largeContractor: largeContractor,
	});

	const QuickAdEndUserValidationSchema = Yup.object({
		firstName: firstName,
		lastName: lastName,
		mobileNumber: mobileNumber,
		endUserCategory: endUserCategory,
		primaryDealer: primaryDealer,
		wssTerritory: wssTerritory,
		town: town,
		zipcode: zipcode,
	});

	const TSIContractorFormValidationSchema = Yup.object({
		...TSIContractorFormFields,
	});

	const factoryValidation = Yup.object({
		factoryName: factoryName,
		factoryLocation: factoryLocation,
		brandNoticed: brandNoticed,
		brand: brand,
		chargeToVisitContractor: chargeToVisitContractor,
		brandOthers: brandOthers,
		largeContractor: largeContractor,
		feedback: factory_visit_feedback,
	});

	const AddMicroSiteLeadValidationSchema = Yup.object({
		siteName: siteName,
		siteLocation: siteLocation,
		siteSpecialist: siteSpecialist,
		superVisorName: superVisorName,
		superVisorNumber: superVisorNumber,
	});

	const SiteAddressSSValidationSchema = Yup.object({
		dealerName: dealerName,
		gluePotentialOfSite: gluePotentialOfSite,
		architect_details: architect_details,
		owner_details: owner_details,
		veneer: veneer,
		isContractorAvailable: isContractorAvailable,
		productComplaintLast1Month: productComplaintLast1Month,
		complaintProductsList: complaintProductsList,
		productComplaintDescription: productComplaintDescription,
		customProductComplaintDescription: customProductComplaintDescription,
	});

	const LmsSiteInfoValidationSchema = Yup.object({
		siteName: siteName,
		siteLocation: siteLocation,
		siteType: siteType,
		typeOfProperty: typeOfProperty,
		propertyArea: propertyArea,
		siteStage: siteStage,
	});

	const LmsMeetingDetailsValidationSchema = Yup.object({
		contractorType: contractType,
		contractorName: Yup.string().when('contractorType', {
			is: (contractorType: string) => contractorType && contractorType !== 'NONE',
			then: (schema) =>
				schema
					.required('Contractor Name is required')
					.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed'),
			otherwise: (schema) => schema.notRequired(),
		}),
		contractorPhoneNumber: Yup.string().when('contractorType', {
			is: (contractorType: string) => contractorType && contractorType !== 'NONE',
			then: (schema) => schema.required('Phone Number is required').matches(phoneRegExp, 'Phone number is not valid'),
			otherwise: (schema) => schema.notRequired(),
		}),
		homeOwnerDetails: owner_details,
		architectDetails: architect_details,
		assigneCmdi: assigneCmdi,
	});

	const LmsGlueDetailsValidationSchema = Yup.object({
		glueUsedAtSite: glueUsedAtSite,
		gradeUsed: gradeUsed,
		brandAvailable: brandAvailable,
		gluePotentialOfSite: gluePotentialOfSite,
		competitionReason: competitionReason,
		glueUsedSoFar: glueUsedSoFar,
		conversionPotential: conversionPotential,
		substratesCombinations: substratesCombinations,
	});

	const LmsOtherInfoValidationSchema = Yup.object({
		siteSubStage: siteSubStage,
		tentativeNextVisit: tentativeNextVisit,
		gluePotentialOfSite: gluePotentialOfSite,
		contractorType: contractType,
		contractorName: Yup.string().when('contractorType', {
			is: (contractorType: string) => contractorType && contractorType !== 'NONE',
			then: (schema) =>
				schema
					.required('Contractor Name is required')
					.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed'),
			otherwise: (schema) => schema.notRequired(),
		}),
		contractorPhoneNumber: Yup.string().when('contractorType', {
			is: (contractorType: string) => contractorType && contractorType !== 'NONE',
			then: (schema) => schema.required('Phone Number is required').matches(phoneRegExp, 'Phone number is not valid'),
			otherwise: (schema) => schema.notRequired(),
		}),
		tilingContractorDetails: Yup.array()
			.of(
				Yup.object().shape({
					id: Yup.number(),
					isActive: Yup.boolean(),
					name: Yup.string()
						.nullable()
						.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name'),
					number: Yup.string()
						.nullable()
						.matches(phoneRegExp, 'Phone number is not valid')
						.test('length', 'Phone number must be 10 digits', (value) => !value || value?.length === 10),
					avg_monthly_tile_adhesive_consumption: Yup.string().nullable(),
				})
			)
			.nullable(),
	});

	const LmsSiteVisitValidationSchema = Yup.object({
		glueConsumed: glueConsumed,
		personAtSite: personAtSite,
		reasonForCompetition: reasonForCompetition,
		personConvince: personConvince,
		followUpDate: followUpDate,
		productDemo: productDemo,
		unsuccessfulDemoReason: unsuccessfulDemoReason,
		conversionVolume: conversionVolume,
		fevicolProduct: fevicolProduct,
		totalConversionVolume: totalConversionVolume,
		conversionType: conversionType,
		followUpReason: followUpReason,
		followUpDateForVisit3Plus: followUpDateForVisit3Plus,
		siteVisitCount: Yup.number().required(),
		conversionPotential: Yup.number().nullable(),
	});

	const LmsContractorDetailsValidationSchema = Yup.object({
		typeOfContracts: contractType,
		noOfSites: noOfSites,
		contractorPotentialPerMonth: contractorPotentialPerMonth,
	});
	const SiteSummaryValidationSchema = Yup.object({
		architect_details: architect_details,
		owner_details: owner_details,
	});

	const RBDMAddMeetingValidationSchema = Yup.object({
		meetingType: meetingType,
		startdate: startdate,
		enddate: enddate,
		start_time_c: start_time_c,
		end_time_c: end_time_c,
		name: name,
		meetingVenue: meetingVenue,
		meetingTheme: meetingTheme,
		rbdmTown: rbdmTown,
	});

	const AddMDPMeetingValidationSchema = Yup.object({
		meetingType: meetingType,
		mdicode_c: Yup.string().required('BDE is required'),
		cmditownlist_c: meetingMdpClub,
		meetSubCategory: Yup.string().when(['meetingType'], {
			is: (meetingType: string) => meetingType === 'Social Meets' || meetingType === 'OTHER SOCIAL ACTIVITIES',
			then: (schema) => schema.required('Social Meet Sub-Type is required'),
			otherwise: (schema) => schema.notRequired(),
		}),
		participantspermeeting_c: Yup.number()
			.transform((value, originalValue) => (originalValue === '' ? undefined : value))
			.required('Number of participants is required')
			.moreThan(0, 'Number of participants must be greater than 0')
			.test('within-available-members', function (value) {
				const availableMembers = this.parent.no_of_participants;
				if (value == null || availableMembers == null || value <= availableMembers) return true;

				return this.createError({
					message: `Estimated members cannot exceed ${availableMembers} available members`,
				});
			}),
		no_of_participants: Yup.number()
			.transform((value, originalValue) => (originalValue === '' ? undefined : value))
			.required('Number of available member is required')
			.when('meetingType', {
				is: (meetingTypeValue: string) => meetingTypeValue?.toLowerCase().includes('ob'),
				then: (schema) => schema.moreThan(0, 'Number of OB member must be greater than 0'),
				otherwise: (schema) => schema.moreThan(0, 'Number of FCC member must be greater than 0'),
			}),
		financial_year_c: Yup.string().required('Year is required'),
		town_c: Yup.string().required('Town is required'),
		plan_budget_c: Yup.string().required('Budget is required'),
		monthname_c: Yup.string().required('Month is required'),
		focus_product_1: Yup.string().when(['meetingType'], {
			is: (meetingType: string) =>
				meetingType == 'Product Specific User Events' || meetingType == 'FCC PRODUCT AWARENESS MEET',
			then: (schema) => schema.required('Primary Focus Product is required'),
			otherwise: (schema) => schema.notRequired(),
		}),
	});

	const PotentialRigidModalValidationSchema = Yup.object({
		competitionBrands: Yup.string().trim().required('Competition Brand(s) is required'),
		estimatedMonthlyCompetitionVolume: Yup.string().trim().required('Estimated Monthly Competition Volume is required'),
		reasonForCompetitionNonConversion: Yup.string()
			.trim()
			.required('Reason for Competition & Non-Conversion is required'),
	});

	const getRigidStatusModalValidationSchema = (actionLabel: string): Yup.ObjectSchema<{ reason: string }> =>
		Yup.object({
			reason: Yup.string().trim().required(`Reason for ${actionLabel} is required`),
		});

	return {
		basicDetailsValidationSchema,
		KYCDetailsValidationSchema,
		MoreDetailsValidationSchema,
		AddSiteLeadValidationSchema,
		AddKAESSSiteLeadValidationSchema,
		SiteAddressValidationSchema,
		SiteProductsValidationSchema,
		TaskListValidationSchema,
		CalendarSchema,
		AddMeetingValidationSchema,
		AddUserSchema,
		UpdateMeetingValidationSchema,
		NonEndUserSchema,
		FeedbackValidationSchema,
		ExpenseValidationSchema,
		DealerVisitValidationSchema,
		OneToOneMeetingValidationSchema,
		QuickAdEndUserValidationSchema,
		TSIContractorFormValidationSchema,
		supervisorValidation,
		factoryValidation,
		brandOthers,
		AddMicroSiteLeadValidationSchema,
		SiteAddressSSValidationSchema,
		RBDMAddMeetingValidationSchema,
		LmsSiteInfoValidationSchema,
		LmsMeetingDetailsValidationSchema,
		LmsGlueDetailsValidationSchema,
		LmsOtherInfoValidationSchema,
		LmsSiteVisitValidationSchema,
		LmsContractorDetailsValidationSchema,
		SiteSummaryValidationSchema,
		AddMDPMeetingValidationSchema,
		PotentialRigidModalValidationSchema,
		getRigidStatusModalValidationSchema,
	};
};
